import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRecentJournals,
  resetStateUploads,
} from "../../app/slices/uploadSlice";
import EmptyDataContainer from "../emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../errorContainer/errorContainer";
import LoadingContainer from "../loadingContainer/loadingContainer";
import "./JournalsHighlight.css";

const JournalsHighlight = () => {
  const {
    list: journals,
    status,
    error,
  } = useSelector(({ uploads }) => uploads.getRecentJournals);

  const dispatch = useDispatch();

  // const journals = [
  //   {
  //     title: "Monthly Economic Review January 2025",
  //     date: "29-Jan-2025",
  //     coverImage:
  //       "https://img.freepik.com/free-vector/flat-driving-school-annual-report-template_23-2149258464.jpg?t=st=1737382851~exp=1737386451~hmac=f9f0350c9e0eeabe6d065ac83f52a26dd9e4e399196ce84148c2c203f3c037aa&w=740",
  //   },
  //   {
  //     title: "Annual Economic Report 2023/2024",
  //     date: "30-Jun-2024",
  //     coverImage:
  //       "https://img.freepik.com/premium-vector/vector-creative-report-business-book-cover-design-modern-company-profile-brochure-cover-template_940023-247.jpg?w=740",
  //   },
  //   {
  //     title: "Some Other Journal Report",
  //     date: "30-Jun-2024",
  //     coverImage:
  //       "https://img.freepik.com/premium-vector/vector-creative-report-business-book-cover-design-modern-company-profile-brochure-cover-template_940023-264.jpg?w=740",
  //   },
  //   {
  //     title: "Another One Report",
  //     date: "30-Jun-2024",
  //     coverImage:
  //       "https://img.freepik.com/free-vector/abstract-elegant-winter-book-cover_23-2148798745.jpg?t=st=1737382799~exp=1737386399~hmac=cb2ae06f06d3c06dd5d0054673bf06307b42f332681f21e00419831a03e72b86&w=740",
  //   },
  // ];

  //use effects
  useEffect(() => {
    dispatch(resetStateUploads(["getRecentJournals"]));
    dispatch(fetchRecentJournals());
  }, [dispatch]);

  //builders
  return (
    <div id="journals-container">
      {status === "loading" && (
        <LoadingContainer message="Working on it..." hasBackground={false} />
      )}

      {journals?.length === 0 && status === "idle" && (
        <EmptyDataContainer
          message="No recent journals found."
          hasBackground={false}
        />
      )}

      {error !== null && status !== "loading" && (
        <ErrorContainer
          message={error?.message}
          hasBackground={false}
          onReload={() => {
            dispatch(resetStateUploads(["getRecentJournals"]));
            dispatch(fetchRecentJournals());
          }}
        />
      )}

      {journals?.length > 0 && status === "idle" && (
        <div className="journals-items-wrapper">
          {journals.map((item) => (
            <a href={item.FILE_PATH} target="_blank" rel="noreferrer">
              <div className="journal-highlight-item">
                <div className="img">
                  <img
                    src={item.COVER_IMAGE || "/placeholder-book.svg"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/placeholder-book.svg";
                    }}
                    alt=""
                  />
                </div>
                <div className="title">{item.TITLE}</div>
                <div className="date">
                  <span>Posted on : </span>
                  {(() => {
                    if (!item.CREATED_AT || item.CREATED_AT === "null") return "Unknown";
                    const isFormatValid = moment(item.CREATED_AT, "DD-MM-YYYY HH:mm:ss", true).isValid();
                    const isStandardValid = moment(item.CREATED_AT).isValid();
                    if (!isFormatValid && !isStandardValid) return "Unknown";
                    return isFormatValid 
                      ? moment(item.CREATED_AT, "DD-MM-YYYY HH:mm:ss").format("Do MMM YYYY") 
                      : moment(item.CREATED_AT).format("Do MMM YYYY");
                  })()}
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default JournalsHighlight;
